import React from 'react';
import PropTypes from 'prop-types';
import LayoutA from '../LayoutA';
import LayoutB from '../LayoutB';
import LayoutC from '../LayoutC';
import LayoutD from '../LayoutD';
import LayoutE from '../LayoutE';
import LayoutL from '../LayoutL';
import LayoutM from '../LayoutM';
import LayoutN from '../LayoutN';
import LayoutO from '../LayoutO';
import DynamicLayout from '../DynamicLayout/DynamicLayout';

export const LAYOUTS_MAP = {
  LAYOUT_A: 1,
  LAYOUT_B: 2,
  LAYOUT_C: 3,
  LAYOUT_D: 4,
  LAYOUT_E: 5,
  LAYOUT_G: 6,
  LAYOUT_H: 7,
  LAYOUT_I: 8,
  LAYOUT_J: 9,
  LAYOUT_K: 10,
  LAYOUT_L: 11,
  LAYOUT_M: 12,
  LAYOUT_N: 13,
  LAYOUT_O: 14,
};

const LayoutHandler = ({ layoutId, dateState, ...rest }) => {
  switch (layoutId) {
    case LAYOUTS_MAP.LAYOUT_A:
      return <LayoutA
      dateState={dateState}
      {...rest} />;

    case LAYOUTS_MAP.LAYOUT_B:
      return <LayoutB
      dateState={dateState}
      {...rest} />;

    case LAYOUTS_MAP.LAYOUT_C:
      return <LayoutC
      dateState={dateState}
      {...rest} />;

    case LAYOUTS_MAP.LAYOUT_D:
      return <LayoutD
      dateState={dateState}
      {...rest} />;

    case LAYOUTS_MAP.LAYOUT_E:
      return <LayoutE
      dateState={dateState}
      {...rest} />;

    case LAYOUTS_MAP.LAYOUT_G:
    case LAYOUTS_MAP.LAYOUT_H:
    case LAYOUTS_MAP.LAYOUT_I:
    case LAYOUTS_MAP.LAYOUT_J:
    case LAYOUTS_MAP.LAYOUT_K:
      return <DynamicLayout id={layoutId}
      dateState={dateState}
      {...rest} />;

    case LAYOUTS_MAP.LAYOUT_L:
      return <LayoutL
      dateState={dateState}
      {...rest} />;

    case LAYOUTS_MAP.LAYOUT_M:
      return <LayoutM
      dateState={dateState}
      {...rest} />;

    case LAYOUTS_MAP.LAYOUT_N:
      return <LayoutN
      dateState={dateState}
      {...rest} />;

    case LAYOUTS_MAP.LAYOUT_O:
      return <LayoutO
      dateState={dateState}
      {...rest} />;

    default:
      return <LayoutA
      dateState={dateState}
      {...rest} />;
  }
};

LayoutHandler.propTypes = {
  layoutId: PropTypes.number.isRequired
};

export default LayoutHandler;
